import React, { useState } from 'react';

import { ArrowDown, ArrowRight, ArrowUp } from '@travel/icons/ui';
import { cx, isNotEmptyArray } from '@travel/utils';

import styles from './linkAccordion.module.scss';

type Props = {
  linkData: {
    name: string;
    url?: string;
    contents?: Array<{ name: string; url?: string }>;
  };
};

const LinkAccordion = (props: Props) => {
  const [isActive, setIsActive] = useState(false);
  const { linkData } = props;

  return (
    <>
      {isNotEmptyArray(linkData.contents) ? (
        <div data-testid="linkAccordion-accordion">
          <button
            className={styles.item}
            onClick={() => setIsActive(!isActive)}
            data-testid="linkAccordion-accordion-button"
          >
            {linkData.name}
            {isActive ? <ArrowUp size={15} /> : <ArrowDown size={15} />}
          </button>

          <div className={styles.accordionContents}>
            {isActive &&
              linkData.contents?.map((accordionContent) => (
                <a
                  key={accordionContent.name}
                  className={cx(styles.accordionContent, styles.link)}
                  data-testid="linkAccordion-accordionContents"
                  href={accordionContent.url ? accordionContent.url : undefined}
                >
                  {<ArrowRight size={15} />}
                </a>
              ))}
          </div>
        </div>
      ) : (
        <a
          className={cx(styles.item, styles.link)}
          href={linkData.url ? linkData.url : undefined}
          data-testid="linkAccordion-link"
        >
          {linkData.name}
          {<ArrowRight size={15} />}
        </a>
      )}
    </>
  );
};

export default LinkAccordion;
